import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import { useLocation, useNavigate } from 'react-router-dom';
import { Stack, Box, Button, CardActionArea, CardMedia, } from '@mui/material';
import { useStore } from '@mcn-platform/models';
import AssetImage from '../../../common/asset/AssetImage';
import SectionInfo from './CourseItemInfo';
import { configureSalesCard } from '../../../common/portalConfig';
import CustomButton from '../../../common/CustomButton';
import ItemHeadline from '../../card/ItemHeadline';
const Instructors = ({ instructors, instructorAction, }) => {
    if (!instructors) {
        return null;
    }
    return (_jsx(Stack, { direction: "row", children: instructors.map((instructor) => (_jsxs(Stack, { direction: "row", children: [_jsx(Box, { sx: { width: 35, height: 35 }, children: _jsx(AssetImage, { avatar: true, asset: instructor.profileImage, customStyle: { width: '100%', height: '100%' }, size: "thumb400w" }) }), _jsx(Button, { onClick: () => (instructorAction && instructorAction(instructor.id)), sx: {
                        fontSize: 12,
                        marginY: 'auto',
                        padding: 0,
                        px: 0.875,
                        textTransform: 'none',
                    }, children: instructor.name })] }, instructor.id))) }));
};
const ItemMediaCard = ({ item }) => {
    const { currentPortal, getItemProgress } = useStore();
    const navigate = useNavigate();
    const location = useLocation();
    // eslint-disable-next-line react/jsx-no-useless-fragment
    if (!(currentPortal && item && item.id))
        return _jsx(_Fragment, {});
    const progress = getItemProgress(item);
    const { action, showButton, buttonLabel, instructorAction, } = configureSalesCard(currentPortal, item, progress, navigate, location, '.', true);
    const { headline, description, instructors, } = item;
    let { length } = item;
    if (item.microcastAsset) {
        length = item.microcastAsset.length;
    }
    const asset = item.itemImage();
    return (_jsxs(Box, { sx: { display: 'inline-flex', flexDirection: { xs: 'column', sm: 'row' } }, children: [_jsx(Box, { sx: { height: 154.13 }, children: item.checkAccess()
                    ? (_jsx(CardActionArea, { onClick: () => {
                            if (action) {
                                action();
                            }
                        }, children: _jsx(CardMedia, { children: _jsx(AssetImage, { asset: asset, customStyle: { width: 274, height: 154.13, objectFit: 'cover' }, size: asset === 'video' ? 'videoThumb' : 'thumb400w' }) }) }))
                    : (_jsx(AssetImage, { asset: asset, customStyle: { width: 274, height: 154.13, objectFit: 'cover' }, size: asset?.type === 'video' ? 'videoThumb' : 'thumb400w' })) }), _jsxs(Box, { sx: {
                    pl: { sm: 2, xs: 0 },
                    pt: { sm: 0, xs: 2 },
                }, children: [_jsx(ItemHeadline, { headline: headline, description: description, size: "medium", isShowMore: true }), (instructors || length !== '') && (_jsxs(Stack, { children: [_jsxs(Stack, { direction: "row", sx: { py: 1.5 }, children: [length !== '' && (_jsx(SectionInfo, { sectionItem: item })), _jsx(Instructors, { instructors: instructors, instructorAction: instructorAction })] }), _jsx(Stack, { direction: "row", sx: { py: 1.5 }, children: showButton && (_jsx(CustomButton, { variant: "outlined", label: buttonLabel, onClick: () => action && action(), customStyle: { flexGrow: 0, minWidth: '200px' } })) })] }))] })] }));
};
export default observer(ItemMediaCard);
//# sourceMappingURL=ItemMediaCard.js.map